import type {
  ClipboardPayload,
  ClipboardPayloadSerializer,
  ClipboardSourceAdapter,
} from './tableClipboard.helper.types'

export const tsvClipboardSourceAdapter: ClipboardSourceAdapter = {
  toClipboardPayload(clipboardText: string): ClipboardPayload {
    // On Windows, rows are split with "\r\n" while macOS/Linux typically use "\n".
    // Normalise to "\n" first so trailing-newline stripping is format-agnostic.
    const normalizedText = clipboardText.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
    // Drop trailing empty lines that clipboard software commonly appends.
    const trimmedText = normalizedText.replace(/\n+$/, '')
    return trimmedText.split('\n').map((line) => line.split('\t'))
  },
}

export const tsvClipboardPayloadSerializer: ClipboardPayloadSerializer = {
  fromClipboardPayload(payload: ClipboardPayload): string {
    return payload.map((row) => row.join('\t')).join('\n')
  },
}

export function isRectangularClipboardPayload(payload: ClipboardPayload): boolean {
  if (payload.length === 0) {
    return true
  }

  const firstRowLength = payload[0].length
  return payload.every((row) => row.length === firstRowLength)
}
